import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=243d18cc&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/AboutUs-pc.css?vue&type=style&index=0&id=243d18cc&scoped=true&lang=css&"
import style1 from "../assets/css/AboutUs-phone.css?vue&type=style&index=1&id=243d18cc&scoped=true&lang=css&"
import style2 from "./PrivacyPolicy.vue?vue&type=style&index=2&id=243d18cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d18cc",
  null
  
)

export default component.exports